<template>
  <div class="rounded-md">
    <div class="px-16 py-12 border-border border rounded-md flex justify-between items-center h-56" @click="modalOpen = true">
      <div
        class="base"
        :class="{
          'text-dark': !selectedString,
          'text-darker': selectedString,
        }"
      >
        {{ selectedString || 'Välj..' }}
      </div>
      <div class="flex items-center">
        <ion-icon
          aria-hidden="true"
          :icon="chevronDown"
          class="text-primary-default w-14 h-14 ml-12"
        />
      </div>
    </div>

    <Modal
      :open="modalOpen"
      :initial-breakpoint="1"
      :breakpoints="[0, 1]"
      @close="modalOpen = false"
    >
      <div class="pt-96 relative">
        <div class="px-16 pt-24 fixed top-0 right-0 left-0 bg-white z-10 border-b border-border">
          <TextInput
            class="mb-16"
            placeholder="Ange produktnamn"
            type="text"
            :value="input"
            @on-input="(inputText) => input = inputText"
          />
        </div>
        <div class="pt-16 px-16 pb-48">
          <div
            v-for="option in suggestions"
            :key="option.value"
            :value="option.value"
            class="w-full flex justify-between items-center py-8 border-b border-border"
          >
            <label class="flex w-full items-center">
              <div class="basis-[30px]">
                <input
                  class="radio"
                  type="radio"
                  name="radioOptions"
                  :checked="selectedValue === option.value"
                  @click="checkOption(option.value)"
                >
              </div>
              <div class="flex justify-between items-center flex-1">
                <div>
                  <div>
                    {{ option.value }}
                  </div>
                </div>
              </div>
            </label>
          </div>
          <div
            class="w-full flex justify-between items-center py-8 border-b border-border"
          >
            <label class="flex w-full items-center">
              <div class="basis-[30px]">
                <input
                  class="radio"
                  type="radio"
                  name="radioOptions"
                  :checked="!selectedValue"
                  @click="checkOption('')"
                >
              </div>
              <div class="flex justify-between items-center flex-1">
                <div>
                  <div>
                    {{ 'Annat' }}
                  </div>
                </div>
              </div>
            </label>
          </div>
          <div class="pt-32">
            <Button
              class="mb-12"
              :text="'Bekräfta'"
              :type="'primary'"
              @click="submitChange"
            />
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script lang="ts" setup>

import { computed, ref } from 'vue';
import { IonIcon } from '@ionic/vue';
import Modal from '@/components/Modal.vue';
import { chevronDown } from 'ionicons/icons';
import TextInput from '@/components/form-elements/TextInput.vue';
import Button from '@/components/Button.vue';

const props = defineProps<{
  options: { type: number; value: string; order: number }[];
  defaultValue?: string | number;
}>();

const input = ref('');

const selectedValue = ref(props.defaultValue ? props.defaultValue : null);
const modalOpen = ref(false);

const emit = defineEmits<{
  (e: 'onInput', payload: string | number): void;
  (e: 'close'): void;
}>();

const checkOption = (input: string | number) => {
  selectedValue.value = input;
  emit('onInput', selectedValue.value);
};

const submitChange = () => {
  emit('onInput', selectedValue.value);
  modalOpen.value = false;
};

const selectedString = computed(() => {
  return props.options.find(option => option.value === selectedValue.value)?.value || null;
});

const suggestions = computed(() => {
  const pattern =  new RegExp(input.value.toLowerCase(), 'g');
  return props.options.filter(option => option.value.toLowerCase().match(pattern));
});

</script>
